import React, { useState } from "react";
import Modal from "../../Common/Modal/Modal";
import { useDispatch } from "react-redux";
import { logoutActionHandler } from "../../../store/actions/actionHandlers/loginActionHandler";
import { useNavigate } from "react-router";
import classes from "./ChangePasswordModal.module.scss";
import ChangePasswordForm from "./ChangePasswordForm";

const ChangePasswordModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [changePasswordCompleteModal, setChangePasswordCompleteModal] =
    useState(false);

  const handleComplete = () => {
    dispatch(logoutActionHandler(navigate));
  };

  return (
    <React.Fragment>
      <Modal
        isOpen={changePasswordModal}
        heading={"Change Password"}
        toggle={() => setChangePasswordModal(false)}
        width={"82"}
        height={"35"}
        canClose={false}
      >
        <ChangePasswordForm
          setChangePasswordModal={setChangePasswordModal}
          setChangePasswordCompleteModal={setChangePasswordCompleteModal}
        />
      </Modal>
      <Modal
        handleSubmit={() => handleComplete()}
        isOpen={changePasswordCompleteModal}
        heading={"Change Password - Complete"}
        buttonLabel1={"OK"}
        canClose={false}
        width={"50"}
        height={"25"}
      >
        <div className={classes.changePassword__complete}>
          <div className={classes.changePassword__complete__text}>
            Your password has changed. Please login again using new password.
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ChangePasswordModal;
